import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQueryWithReAuth } from './baseQuery';

// Create base API instance
export const api = createApi({
  baseQuery: dynamicBaseQueryWithReAuth,
  endpoints: () => ({}),
  reducerPath: 'api',
});
